function padStartFn() {
  let fn = String.prototype.padStart
  String.prototype.padStart = function () {
    let cot = this
    try {
      // console.log("我来做兼容了呀::",arguments)
      if (fn) {
        // console.log("兼容的")
        return fn.apply(this, arguments)
      }
      let len = cot.length
      let needlen = arguments[0]
      let repitem = arguments[1]
      let cha = needlen - len
      if (cha > 0) {
        for (let i = 0; i < cha; i++) {
          cot = repitem + cot
        }
      }
      return cot
    } catch (err) {
      // console.log("参数错误")
    }
  }
}
function zhpollify() {
  padStartFn()
}
module.exports = {
  zhpollify
}